import React, {useMemo} from "react";
import {JobApplicationDetails} from "@/data/entities/jobApplication";
import {FormattedMessage} from "react-intl";
import {TextSkeleton} from "peggirkit";

type Props = {
    jobApplication: JobApplicationDetails | undefined,
};

const SentBy = ({jobApplication}: Props) => {
    const formattedName = useMemo(() => {
        if (!jobApplication) {
            return <TextSkeleton className={"inline-block max-w-[130px]"}/>;
        }

        return `${jobApplication.firstName} ${jobApplication.lastName}`;
    }, [jobApplication]);
    const formattedDate = useMemo(() => {
        if (!jobApplication) {
            return <TextSkeleton className={"inline-block max-w-[165px]"}/>;
        }

        return new Date(jobApplication.creationDate).toLocaleString();
    }, [jobApplication]);

    return (
        <div className={"w-full text-gray-500 dark:text-slate-400"}>
            <FormattedMessage
                id={"sentByOn"}
                values={{
                    bold: chunks => (
                        <strong className={"font-medium text-black dark:text-white"}>
                            {chunks}
                        </strong>
                    ),
                    from: formattedName,
                    date: formattedDate,
                }}
            />
        </div>
    );
};

export default SentBy;